import { STEPS_WOOFZ22_V3 } from 'nove8/cohorts/woofz22_v3/constants/steps'
import { STEPS_WOOFZ22_V4 } from 'nove8/cohorts/woofz22_v4/constants/steps'
import { STEPS_WOOFZ22_V4_WT } from 'nove8/cohorts/woofz22_v4_wt/constants/steps'
import { STEPS_WOOFZ22_V4_BG } from 'nove8/cohorts/woofz22_v4_bg/constants/steps'
import { STEPS_WOOFZ22_V4L } from 'nove8/cohorts/woofz22_v4l/constants/steps'
import { STEPS_WOOFZ22_V4T } from 'nove8/cohorts/woofz22_v4t/constants/steps'
import { STEPS_WOOFZ22_V9 } from 'nove8/cohorts/woofz22_v9/constants/steps'
import { STEPS_WOOFZ_COACHING } from 'nove8/cohorts/woofz_coaching/constants/steps'
import { STEPS_WOOFZ_EASTER_65 } from 'nove8/cohorts/woofz_easter/woofz_easter_65/constants/steps'
import { STEPS_WOOFZ_EASTER_70 } from 'nove8/cohorts/woofz_easter/woofz_easter_70/constants/steps'
import { STEPS_WOOFZ_EASTER_75 } from 'nove8/cohorts/woofz_easter/woofz_easter_75/constants/steps'
import { STEPS_WOOFZ_EASTER_80 } from 'nove8/cohorts/woofz_easter/woofz_easter_80/constants/steps'
import { STEPS_WOOFZ_ESA } from 'nove8/cohorts/woofz_esa/constants/steps'
import { STEPS_WOOFZ_HLWN_65 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_65/constants/steps'
import { STEPS_WOOFZ_HLWN_70 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_70/constants/steps'
import { STEPS_WOOFZ_HLWN_75 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_75/constants/steps'
import { STEPS_WOOFZ_HLWN_80 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_80/constants/steps'
import { STEPS_WOOFZ_INVX } from 'nove8/cohorts/woofz_invx/constants/steps'
import { STEPS_WOOFZ_K9 } from 'nove8/cohorts/woofz_k9/constants/steps'
import { STEPS_WOOFZ_K9_BL } from 'nove8/cohorts/woofz_k9_bl/constants/steps'
import { STEPS_WOOFZ_K9_BL_BG } from 'nove8/cohorts/woofz_k9_bl_bg/constants/steps'
import { STEPS_WOOFZ_K9_DRSL } from 'nove8/cohorts/woofz_k9_drsl/constants/steps'
import { STEPS_WOOFZ_LOVE } from 'nove8/cohorts/woofz_love/constants/steps'
import { STEPS_WOOFZ_LOVE_BL } from 'nove8/cohorts/woofz_love_bl/constants/steps'
import { STEPS_WOOFZ_NDD_65 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_65/constants/steps'
import { STEPS_WOOFZ_NDD_70 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_70/constants/steps'
import { STEPS_WOOFZ_NDD_75 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_75/constants/steps'
import { STEPS_WOOFZ_NDD_80 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_80/constants/steps'
import { STEPS_WOOFZ_NDD } from 'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/constants/steps'
import { STEPS_WOOFZ_NPDAY_65 } from 'nove8/cohorts/woofz_npday/woofz_npday_65/constants/steps'
import { STEPS_WOOFZ_NPDAY_70 } from 'nove8/cohorts/woofz_npday/woofz_npday_70/constants/steps'
import { STEPS_WOOFZ_NPDAY_75 } from 'nove8/cohorts/woofz_npday/woofz_npday_75/constants/steps'
import { STEPS_WOOFZ_NPDAY_80 } from 'nove8/cohorts/woofz_npday/woofz_npday_80/constants/steps'
import { STEPS_WOOFZ_NRDAY_65 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_65/constants/steps'
import { STEPS_WOOFZ_NRDAY_70 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_70/constants/steps'
import { STEPS_WOOFZ_NRDAY_75 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_75/constants/steps'
import { STEPS_WOOFZ_NRDAY_80 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_80/constants/steps'
import { STEPS_WOOFZ_OFFER1_65 } from 'nove8/cohorts/woofz_offer/woofz_offer1_65/constants/steps'
import { STEPS_WOOFZ_OFFER1_70 } from 'nove8/cohorts/woofz_offer/woofz_offer1_70/constants/steps'
import { STEPS_WOOFZ_OFFER1_75 } from 'nove8/cohorts/woofz_offer/woofz_offer1_75/constants/steps'
import { STEPS_WOOFZ_OFFER1_80 } from 'nove8/cohorts/woofz_offer/woofz_offer1_80/constants/steps'
import { STEPS_WOOFZ_OFFER2_70 } from 'nove8/cohorts/woofz_offer/woofz_offer2_70/constants/steps'
import { STEPS_WOOFZ_OFFER2_75 } from 'nove8/cohorts/woofz_offer/woofz_offer2_75/constants/steps'
import { STEPS_WOOFZ_PAW_NUP } from 'nove8/cohorts/woofz_paw_nup/constants/steps'
import { STEPS_WOOFZ_PN } from 'nove8/cohorts/woofz_pn/constants/steps'
import { STEPS_WOOFZ_PPDAY_65 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_65/constants/steps'
import { STEPS_WOOFZ_PPDAY_70 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_70/constants/steps'
import { STEPS_WOOFZ_PPDAY_75 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_75/constants/steps'
import { STEPS_WOOFZ_PPDAY_80 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_80/constants/steps'
import { STEPS_WOOFZ_PPP } from 'nove8/cohorts/woofz_ppp/constants/steps'
import { STEPS_WOOFZ_PPP_BL } from 'nove8/cohorts/woofz_ppp_bl/constants/steps'
import { STEPS_WOOFZ_PPP_WOOFY } from 'nove8/cohorts/woofz_ppp_woofy/constants/steps'
import { STEPS_WOOFZ_PT1 } from 'nove8/cohorts/woofz_pt1/constants/steps'
import { STEPS_WOOFZ_PT1_BG } from 'nove8/cohorts/woofz_pt1_bg/constants/steps'
import { STEPS_WOOFZ_PUP } from 'nove8/cohorts/woofz_pup/constants/steps'
import { STEPS_WOOFZ_PUP_BL } from 'nove8/cohorts/woofz_pup_bl/constants/steps'
import { STEPS_WOOFZ_PUP_DRSL } from 'nove8/cohorts/woofz_pup_drsl/constants/steps'
import { STEPS_WOOFZ_PUP_WT } from 'nove8/cohorts/woofz_pup_wt/constants/steps'
import { STEPS_WOOFZ_RFND3 } from 'nove8/cohorts/woofz_rfnd3/constants/steps'
import { STEPS_WOOFZ_RFND3_ND } from 'nove8/cohorts/woofz_rfnd3_nd/constants/steps'
import { STEPS_WOOFZ_RT } from 'nove8/cohorts/woofz_rt/constants/steps'
import { STEPS_WOOFZ_S1_6_12 } from 'nove8/cohorts/woofz_s/woofz_s1_6_12/constants/steps'
import { STEPS_WOOFZ_S2_6_12 } from 'nove8/cohorts/woofz_s/woofz_s2_6_12/constants/steps'
import { STEPS_WOOFZ_S3_6_12 } from 'nove8/cohorts/woofz_s/woofz_s3_6_12/constants/steps'
import { STEPS_WOOFZ_SMD } from 'nove8/cohorts/woofz_smd/constants/steps'
import { STEPS_WOOFZ_SMD_BL } from 'nove8/cohorts/woofz_smd_bl/constants/steps'
import { STEPS_WOOFZ_SUB_CNLD_70 } from 'nove8/cohorts/woofz_sub_cnld_70/constants/steps'
import { STEPS_WOOFZ_VC6 } from 'nove8/cohorts/woofz_vc6/constants/steps'
import { STEPS_WOOFZ_VDAY_65 } from 'nove8/cohorts/woofz_vday/woofz_vday_65/constants/steps'
import { STEPS_WOOFZ_VDAY_70 } from 'nove8/cohorts/woofz_vday/woofz_vday_70/constants/steps'
import { STEPS_WOOFZ_VDAY_75 } from 'nove8/cohorts/woofz_vday/woofz_vday_75/constants/steps'
import { STEPS_WOOFZ_VDAY_80 } from 'nove8/cohorts/woofz_vday/woofz_vday_80/constants/steps'
import { STEPS_WOOFZ_VGS } from 'nove8/cohorts/woofz_vgs/constants/steps'
import { STEPS_WOOFZ_WA1 } from 'nove8/cohorts/woofz_wa1/constants/steps'
import { STEPS_WOOFZ_WOOFY } from 'nove8/cohorts/woofz_woofy1/constants/steps'
import { STEPS_WOOFZ_WS2 } from 'nove8/cohorts/woofz_ws2/constants/steps'
import { STEPS_WOOFZ_XMAS_65 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_65/constants/steps'
import { STEPS_WOOFZ_XMAS_70 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_70/constants/steps'
import { STEPS_WOOFZ_XMAS_80 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_80/constants/steps'
import { TStep } from 'nove8/types'
import { Cohort } from './root-constants'

export const STEPS_MAP: Record<Cohort, TStep[]> = {
  [Cohort.WOOFZ22_V9]: STEPS_WOOFZ22_V9,
  [Cohort.WOOFZ22_V4L]: STEPS_WOOFZ22_V4L,
  [Cohort.WOOFZ_PN]: STEPS_WOOFZ_PN,
  [Cohort.WOOFZ_ESA]: STEPS_WOOFZ_ESA,
  [Cohort.WOOFZ_WS2]: STEPS_WOOFZ_WS2,
  [Cohort.WOOFZ_VGS]: STEPS_WOOFZ_VGS,
  [Cohort.WOOFZ_RFND3_ND]: STEPS_WOOFZ_RFND3_ND,
  [Cohort.WOOFZ_VC6]: STEPS_WOOFZ_VC6,
  [Cohort.WOOFZ22_V3]: STEPS_WOOFZ22_V3,
  [Cohort.WOOFZ_PT1]: STEPS_WOOFZ_PT1,
  [Cohort.WOOFZ22_V4]: STEPS_WOOFZ22_V4,
  [Cohort.WOOFZ_RFND3]: STEPS_WOOFZ_RFND3,
  [Cohort.WOOFZ_PPP]: STEPS_WOOFZ_PPP,
  [Cohort.WOOFZ_PPP_BL]: STEPS_WOOFZ_PPP_BL,
  [Cohort.WOOFZ_PPP_WOOFY]: STEPS_WOOFZ_PPP_WOOFY,
  [Cohort.WOOFZ_PUP]: STEPS_WOOFZ_PUP,
  [Cohort.WOOFZ_PUP_BL]: STEPS_WOOFZ_PUP_BL,
  [Cohort.WOOFZ_LOVE]: STEPS_WOOFZ_LOVE,
  [Cohort.WOOFZ_RT]: STEPS_WOOFZ_RT,
  [Cohort.WOOFZ22_V4T]: STEPS_WOOFZ22_V4T,
  [Cohort.WOOFZ_LOVE_BL]: STEPS_WOOFZ_LOVE_BL,
  [Cohort.WOOFZ_INVX]: STEPS_WOOFZ_INVX,
  [Cohort.WOOFZ_EASTER_65]: STEPS_WOOFZ_EASTER_65,
  [Cohort.WOOFZ_EASTER_70]: STEPS_WOOFZ_EASTER_70,
  [Cohort.WOOFZ_EASTER_75]: STEPS_WOOFZ_EASTER_75,
  [Cohort.WOOFZ_EASTER_80]: STEPS_WOOFZ_EASTER_80,
  [Cohort.WOOFZ_S1_6_12]: STEPS_WOOFZ_S1_6_12,
  [Cohort.WOOFZ_S2_6_12]: STEPS_WOOFZ_S2_6_12,
  [Cohort.WOOFZ_S3_6_12]: STEPS_WOOFZ_S3_6_12,
  [Cohort.WOOFZ_K9]: STEPS_WOOFZ_K9,
  [Cohort.WOOFZ_NPDAY_65]: STEPS_WOOFZ_NPDAY_65,
  [Cohort.WOOFZ_NPDAY_70]: STEPS_WOOFZ_NPDAY_70,
  [Cohort.WOOFZ_NPDAY_75]: STEPS_WOOFZ_NPDAY_75,
  [Cohort.WOOFZ_NPDAY_80]: STEPS_WOOFZ_NPDAY_80,
  [Cohort.WOOFZ_K9_BL]: STEPS_WOOFZ_K9_BL,
  [Cohort.WOOFZ_K9_BL_1]: STEPS_WOOFZ_K9_BL, // OCS testing cohort
  [Cohort.WOOFZ_K9_BL_2]: STEPS_WOOFZ_K9_BL, // OCS testing cohort
  [Cohort.WOOFZ_K9_BL_3]: STEPS_WOOFZ_K9_BL, // OCS testing cohort
  [Cohort.WOOFZ_K9_DRSL]: STEPS_WOOFZ_K9_DRSL,
  [Cohort.WOOFZ_PPDAY_65]: STEPS_WOOFZ_PPDAY_65,
  [Cohort.WOOFZ_XMAS_65]: STEPS_WOOFZ_XMAS_65,
  [Cohort.WOOFZ_XMAS_70]: STEPS_WOOFZ_XMAS_70,
  [Cohort.WOOFZ_XMAS_80]: STEPS_WOOFZ_XMAS_80,
  [Cohort.WOOFZ_PPDAY_70]: STEPS_WOOFZ_PPDAY_70,
  [Cohort.WOOFZ_PPDAY_75]: STEPS_WOOFZ_PPDAY_75,
  [Cohort.WOOFZ_PPDAY_80]: STEPS_WOOFZ_PPDAY_80,
  [Cohort.WOOFZ_WA1]: STEPS_WOOFZ_WA1,
  [Cohort.WOOFZ_OFFER1_65]: STEPS_WOOFZ_OFFER1_65,
  [Cohort.WOOFZ_OFFER1_70]: STEPS_WOOFZ_OFFER1_70,
  [Cohort.WOOFZ_OFFER1_75]: STEPS_WOOFZ_OFFER1_75,
  [Cohort.WOOFZ_OFFER1_80]: STEPS_WOOFZ_OFFER1_80,
  [Cohort.WOOFZ_OFFER2_70]: STEPS_WOOFZ_OFFER2_70,
  [Cohort.WOOFZ_OFFER2_75]: STEPS_WOOFZ_OFFER2_75,
  [Cohort.WOOFZ_VDAY_65]: STEPS_WOOFZ_VDAY_65,
  [Cohort.WOOFZ_VDAY_70]: STEPS_WOOFZ_VDAY_70,
  [Cohort.WOOFZ_VDAY_75]: STEPS_WOOFZ_VDAY_75,
  [Cohort.WOOFZ_VDAY_80]: STEPS_WOOFZ_VDAY_80,
  [Cohort.WOOFZ_HLWN_65]: STEPS_WOOFZ_HLWN_65,
  [Cohort.WOOFZ_HLWN_70]: STEPS_WOOFZ_HLWN_70,
  [Cohort.WOOFZ_HLWN_75]: STEPS_WOOFZ_HLWN_75,
  [Cohort.WOOFZ_HLWN_80]: STEPS_WOOFZ_HLWN_80,
  [Cohort.WOOFZ_SUB_CNLD_70]: STEPS_WOOFZ_SUB_CNLD_70,
  [Cohort.WOOFZ_NDD]: STEPS_WOOFZ_NDD,
  [Cohort.WOOFZ_NDD_65]: STEPS_WOOFZ_NDD_65,
  [Cohort.WOOFZ_NDD_70]: STEPS_WOOFZ_NDD_70,
  [Cohort.WOOFZ_NDD_75]: STEPS_WOOFZ_NDD_75,
  [Cohort.WOOFZ_NDD_80]: STEPS_WOOFZ_NDD_80,
  [Cohort.WOOFZ_WOOFY1]: STEPS_WOOFZ_WOOFY,
  [Cohort.WOOFZ_NRDAY_65]: STEPS_WOOFZ_NRDAY_65,
  [Cohort.WOOFZ_NRDAY_70]: STEPS_WOOFZ_NRDAY_70,
  [Cohort.WOOFZ_NRDAY_75]: STEPS_WOOFZ_NRDAY_75,
  [Cohort.WOOFZ_NRDAY_80]: STEPS_WOOFZ_NRDAY_80,
  [Cohort.WOOFZ_PUP_WT]: STEPS_WOOFZ_PUP_WT,
  [Cohort.WOOFZ_PUP_DRSL]: STEPS_WOOFZ_PUP_DRSL,
  [Cohort.WOOFZ_COACHING]: STEPS_WOOFZ_COACHING,
  [Cohort.WOOFZ_SMD]: STEPS_WOOFZ_SMD,
  [Cohort.WOOFZ_SMD_BL]: STEPS_WOOFZ_SMD_BL,
  [Cohort.WOOFZ_PAW_NUP]: STEPS_WOOFZ_PAW_NUP,
  [Cohort.WOOFZ22_V4_WT]: STEPS_WOOFZ22_V4_WT,
  [Cohort.WOOFZ22_V4_BG]: STEPS_WOOFZ22_V4_BG,
  [Cohort.WOOFZ_PT1_BG]: STEPS_WOOFZ_PT1_BG,
  [Cohort.WOOFZ_K9_BL_BG]: STEPS_WOOFZ_K9_BL_BG,
}
